import { api } from "@api/api";
import { Promocode } from "@modules/promocodes/types";
import { PromocodeFormValues } from "@modules/promocodes/validations";

export async function editPromocodeService(id: string, data: PromocodeFormValues): Promise<Promocode> {
  const { data: promocode } = await api.patch<Promocode>(`v1/promocode_admin/${id}/`, data);

  return promocode;
}
